export const pageLevels: { [key: string]: number } = {
	account: 0,
	settings: 1,
	language: 2
};
